import BaseService from "./BaseService";

export default class PromoCodeServices extends BaseService {
    public static getAllPromoCode(token: string, postData: any) {
        return BaseService.sendRequest(`${process.env.REACT_APP_API_URL}promocode/get-all`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }

    public static getAllCashBackCoupons(token: string, postData: any) {
        return BaseService.sendRequest(`${process.env.REACT_APP_API_URL}cashback/get-all`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }

    public static storePromoCode(token: string, postData: any) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'promocode/add', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }

    public static editpromocode(token: string, postData: any) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'promocode/edit', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }

    public static editcoupon(token: string, postData: any) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'cashback/edit', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }

    public static storeCashBackCoupon(token: string, postData: any) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'cashback/add', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }

    public static UpdatePromoCodeStatus(token: string, promoCodeGuid: string, isActive: number) {
        return BaseService.sendRequest(`${process.env.REACT_APP_API_URL}promocode/update-status/${promoCodeGuid}/${isActive}`, {
            method: 'get',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            }
        })
    }

    public static UpdateCashBackCouponStatus(token: string, promoCodeGuid: string, isActive: number) {
        return BaseService.sendRequest(`${process.env.REACT_APP_API_URL}cashback/update-status/${promoCodeGuid}/${isActive}`, {
            method: 'get',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            }
        })
    }

    public static getAllInfluences(token: string) {
        return BaseService.sendRequest(`${process.env.REACT_APP_API_URL}promocode/influence-list`, {
            method: 'get',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            }
        })
    } 

    public static getPromocodeDetails(token: string, postData: any, promo_code_id: any) {
        return BaseService.sendRequest(`${process.env.REACT_APP_API_URL}promocode/get-promo-code-user-mapping/${promo_code_id}`, {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }
}